/**
 * Stable ids for game-agnostic fill-layout algorithms under common/utils map-gen.
 * Consumers select an algorithm by this id.
 *
 * - open: no fill tiles; open field / baseline for pathing probes.
 * - singleRightAnglesAndLines: straight segments and single-bend L stamps, then short
 *   scatter strips to spend remaining budget.
 * - gapAwareOrganicWalls: gap-aware organic wall lines that grow from free starts and
 *   avoid crowding other fill clusters.
 * - angledWallsAndStrips: mix of diagonal-biased wall lines plus axis-aligned gapped strips,
 *   then scatter top-up.
 * - axisAlignedGappedStrips: axis-aligned strips only, with open gaps between clusters.
 * - diagonalBiasedWalls: diagonal-biased random wall lines (long slanted walls, no strip mix).
 */
export const MAP_GEN_FILL_LAYOUT_IDS = [
  'open',
  'singleRightAnglesAndLines',
  'gapAwareOrganicWalls',
  'angledWallsAndStrips',
  'axisAlignedGappedStrips',
  'diagonalBiasedWalls'
] as const;

export type MapGenFillLayoutId = (typeof MAP_GEN_FILL_LAYOUT_IDS)[number];

export function isMapGenFillLayoutId(value: string): value is MapGenFillLayoutId {
  return (MAP_GEN_FILL_LAYOUT_IDS as readonly string[]).includes(value);
}
